import { Separator } from "@/components/ui/separator";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/transaktionen",
)({
  component: TransaktionenLayout,
});

function TransaktionenLayout() {
  return (
    <div className="flex flex-col h-full w-full gap-2">
      <div className="flex-1 bg-slate-50">
        <Outlet />
      </div>
    </div>
  );
}
